module.exports = __webpack_public_path__ + "static/media/Group.67e9f4e8.png";